import { render, staticRenderFns } from "./cupones-descuento-evento.vue?vue&type=template&id=54a6b02a&"
import script from "./cupones-descuento-evento.vue?vue&type=script&lang=js&"
export * from "./cupones-descuento-evento.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports